import React from 'react';
import { createStyleSheet } from 'utils/helpers';
import imageUpgrade from 'assets/images/backgrounds/upgrade-bg.svg';
import { colors } from 'common/constants';
import { common } from '@mui/material/colors';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
interface UpgradeProps {
    openSidebar: boolean;
}
const Upgrade: React.FC<UpgradeProps> = ({ openSidebar }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <>
            {openSidebar && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                >
                    <Box sx={styles.upgrade}>
                        <Typography variant="h6" sx={styles.upgrade.title}>
                            {t('advanced.package')}
                        </Typography>
                        <Typography sx={styles.upgrade.description}>
                            {t('accept.all.features')}
                        </Typography>
                        <Button
                            sx={styles.upgrade.btn}
                            onClick={() =>
                                navigate('/admin/upgrade-service-package')
                            }
                        >
                            {t('common.upgrade')}
                        </Button>
                    </Box>
                </Box>
            )}
        </>
    );
};
const styles = createStyleSheet({
    upgrade: {
        marginTop: '100px',
        width: '223px',
        height: '164px',
        backgroundImage: `url(${imageUpgrade})`,
        backgroundRepeat: 'no-repeat',
        padding: '24px 18px 24px 18px',
        textAlign: 'center',
        whiteSpace: 'normal',
        color: colors.main,
        title: {
            fontWeight: 700,
            fontSize: '20px',
            lineHeight: '24px',

            marginBottom: '12px',
        },
        description: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '17px',
            marginBottom: '19px',
        },
        btn: {
            width: '120px',
            height: '30px',
            backgroundColor: colors.main,
            color: common.white,
            borderRadius: '109.67px',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '17px',
            '&:hover': {
                backgroundColor: colors.main,
            },
        },
    },
});
export default Upgrade;
